$(document).ready(function() {

    $('.collection-list__grid').slick({
        dots: true,
        arrows: false,
        infinite: true,
        swipeToSlide: true,
        accessibility: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1080,
                settings: "unslick"
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }
        ]
    });

    if($(window).width() >= 1080){
        $('.collection-list__item a').removeAttr('tabindex');
        $('.collection-list__item').removeAttr('tabindex');
        $('.collection-list__item').removeAttr('role');
        $('.collection-list__item').removeAttr('aria-label');
        $('.collection-list__item').removeAttr('aria-describedby');
        $('.collection-list__item').removeAttr('aria-hidden');
    }

});

$(window).resize(function(){
    if($(window).width() < 1080){
        $('.collection-list__grid').slick('slickAdd');
    }
});